import type { ReactNode } from 'react';

interface MetricCardsGridProps {
  children: ReactNode;
}

export function MetricCardsGrid({ children }: MetricCardsGridProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {children}
    </div>
  );
}
